import { animate, style, transition } from '@angular/animations';

export const enterTransition = transition(':enter', [
  style({
    opacity: 0,
  }),
  animate('0.5s ease-in', style({ opacity: 1 })),
]);

export const leaveTransition = transition(':leave', [
  style({
    opacity: 1,
  }),
  animate('0s ease-in', style({ opacity: 0 })),
]);

export const enterInOutTransition = transition(':enter', [
  style({ opacity: 0, transform: 'translateX(-100%)' }), //apply default styles before animation starts
  animate(
    '750ms ease-in-out',
    style({ opacity: 1, transform: 'translateX(0)' })
  ),
]);

export const leaveInOutTransition = transition(':leave', [
  style({ opacity: 1, transform: 'translateX(0)' }), //apply default styles before animation starts
  animate(
    '600ms ease-in-out',
    style({ opacity: 0, transform: 'translateX(-100%)' })
  ),
]);
